module.exports = __webpack_public_path__ + "img/Pier_pass_create_desktop_2.351d566c.gif";